import { Path, Svg } from "react-native-svg";
import { createIcon } from "../factories/createIcon";
export const [ShareArrow, AnimatedShareArrow] = createIcon({
  name: "ShareArrow",
  getIcon: (props) => <Svg viewBox="0 0 24 24" fill="none" {...props}><Path
    d="M13 4.99092C13 4.09592 14.094 3.66096 14.709 4.31196L20.637 10.582C21.121 11.094 21.121 11.894 20.637 12.406L14.709 18.676C14.094 19.326 13 18.891 13 17.997V14.4919C5.437 14.4919 4.93602 16.962 4.96802 19.529C4.97402 20.019 4.32501 20.1811 4.08301 19.7561C3.46701 18.6751 3 17.1999 3 15.4909C3 8.99592 10 8.49702 13 8.49702V4.99092Z"
    fill={"currentColor"}
  /></Svg>,
  defaultFill: "#9B9B9B"
});
